module.exports = __webpack_public_path__ + "img/2.210a5902.jpg";